// extracted by mini-css-extract-plugin
export default {"root":"app_root__DOtJY","main":"app_main__E1b33"};